var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation } from 'react-query';
import { prepareDataForRequest } from '../../createlist/hooks/helpers';
export var useEditList = function (config) {
    var ky = useOkapiKy();
    var listObject = config.listObject, onSuccess = config.onSuccess, onChangeVersionError = config.onChangeVersionError, _a = config.onError, onError = _a === void 0 ? function () { } : _a, id = config.id, originalVersion = config.version;
    var preparedObject = prepareDataForRequest(listObject);
    var _b = useMutation(['saveEditedList', preparedObject.name], function () { return ky.put('lists/' + id, { json: __assign(__assign({}, preparedObject), { version: originalVersion }) }).json(); }, {
        onSuccess: onSuccess,
        onError: onError
    }), saveList = _b.mutate, savingList = _b.isLoading;
    var _c = useMutation(['checkEditedVersion', preparedObject.name], function () { return ky.get('lists/' + id).json(); }, {
        onSuccess: function (_a) {
            var version = _a.version;
            if (originalVersion === version) {
                saveList();
            }
            else {
                onChangeVersionError();
            }
        },
        onError: onError
    }), checkVersionAndSave = _c.mutate, compareVersionInProgress = _c.isLoading, data = _c.data;
    return ({
        saveList: function () {
            checkVersionAndSave();
        },
        data: data,
        isLoading: compareVersionInProgress || savingList
    });
};
